import ComparePointCloudVirtualTour from './ComparePointCloudVirtualTour';

export default ComparePointCloudVirtualTour;
